import type { Tenant } from "utils/mandators/types";
import { featureFlagsCI } from "../config/featureFlagsCI";
import { featureFlagsACC } from "../config/featureFlagsACC";
import { featureFlagsPROD } from "../config/featureFlagsPROD";
import { FeatureFlagKey } from "./featureFlags.type";
import { isStaging, isProduction } from "utils/environment";
import { createFeatureFlags } from "./createFeatureFlags";

export type FeatureFlagsReadonly = Readonly<
  Record<FeatureFlagKey, Readonly<boolean>>
>;

export const resolveFlags = (tenant: Tenant) => {
  const resolved = Object.fromEntries(
    Object.values(FeatureFlagKey).map((key) => [key, false]),
  ) as Record<FeatureFlagKey, boolean>;
  const featureFlags = getFeatureFlagsByEnvironment();

  const applyIsAllowed = (flag: FeatureFlagKey): boolean => {
    const config = featureFlags[flag];
    if (!config) return false;

    const ownAllowed =
      config.enabled && !config.disabledTenants.includes(tenant);

    const parentAllowed = config.parent ? applyIsAllowed(config.parent) : true;

    return (resolved[flag] = ownAllowed && parentAllowed);
  };

  for (const flag of Object.keys(featureFlags) as FeatureFlagKey[]) {
    applyIsAllowed(flag);
  }

  return Object.freeze(resolved) as FeatureFlagsReadonly;
};

const getFeatureFlagsByEnvironment = () => {
  if (isStaging) {
    return createFeatureFlags(featureFlagsACC);
  }
  if (isProduction) {
    return createFeatureFlags(featureFlagsPROD);
  }
  return createFeatureFlags(featureFlagsCI);
};
